module.exports = __webpack_public_path__ + "img/mall_qrcode.b94a4a55.png";